<template>
	<div class="top">
		<img style="cursor: pointer" @click="goHome" src="../assets/logo.png" id='logo' alt="logo" title='最美证件照制作' />
		<div class='tab-container'>
			<span class='tab' :class="(chosenTab==''||chosenTab=='home')?'chosen':''" data-tab='home' @click="chooseTab">首页</span>
			<span class='tab' :class="chosenTab=='makeHome'?'chosen':''" data-tab='makeHome' @click="chooseTab">证件照制作</span>
<!--			<span class='tab' :class="chosenTab=='introduce'?'chosen':''" data-tab='introduce' @click="chooseTab">产品介绍</span>-->
			<span class='tab' :class="chosenTab=='partners'?'chosen':''" data-tab='partners' @click="chooseTab">合作伙伴</span>
<!--			<span class='tab' :class="chosenTab=='Article'?'chosen':''" data-tab='Article' @click="chooseTab">热门文章</span>-->
			<span class='tab' :class="chosenTab=='Examination'?'chosen':''" data-tab='Examination' @click="chooseTab">考试咨询</span>
		</div>
	</div>
</template>

<script>
	function scrollAnimation(currentY, targetY) {
		// 获取当前位置方法
		// const currentY = document.documentElement.scrollTop || document.body.scrollTop

		// 计算需要移动的距离
		let needScrollTop = targetY - currentY
		let _currentY = currentY
		setTimeout(() => {
			// 一次调用滑动帧数，每次调用会不一样
			const dist = Math.ceil(needScrollTop / 10)
			_currentY += dist
			window.scrollTo(_currentY, currentY)
			// 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
			if (needScrollTop > 10 || needScrollTop < -10) {
				scrollAnimation(_currentY, targetY)
			} else {
				window.scrollTo(_currentY, targetY)
			}
		}, 1)
	}
export default {
  name: 'PageHeader',
  props: {
	linkTo: String
  },
  data(){
		return {
			chosenTab:this.linkTo
		}
  },
  methods:{
		chooseTab:function(e){
			this.chosenTab=e.target.dataset.tab;
			this.$router.push({path:'/'+e.target.dataset.tab});
		},
		goHome(){
			this.$route.path!=='/home'?this.$router.push({
				path:'/home'
			}):scrollAnimation(document.documentElement.scrollTop || document.body.scrollTop,0)
		}
  }
}
</script>

<style scoped="scoped">
	.chosen{
		color: #FF7BAC;
		border-bottom: 3px #FF7BAC solid;
	}
	.top{
		position: fixed;
		top:0;
		z-index: 20;
		background:rgba(255,255,255,1);
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height:90px;
		padding: 0 19%;
		box-sizing: border-box;
	}
	#logo{
		width: 230px;
		flex-shrink: 0;
		flex-grow: 0;
	}
	.tab-container{
		display: inline-block;
		height: 100%;
		flex-shrink: 0;
		flex-grow: 0;
		width: 600px;
		line-height: 90px;
		cursor: pointer;
	}
	.tab{
		display: inline-block;
		width: 70px;
		font-size: 14px;
		margin: 0 25px;
		box-sizing: border-box;
		text-align: center;
	}
	/* @media (min-width: 1923px) {
		.top{
			width:1920px;
			height:90px;
		}
		#logo{
			width: 230px;
		}
		footer{
			padding-bottom: 32px;
			padding-top: 52px;
		}
		.footer-upper-1>img{
			width: 110px;
			margin-bottom: 9px;
		}
	}
	@media (min-width: 1200px) and (max-width: 1922px){
		.top{
			width:1200px;
			height:85px;
		}
		#logo{
			width: 151px;
		}
		footer{
			padding-bottom: 31px;
			padding-top: 31px;
		}
		.footer-upper-1>img{
			width: 110px;
			margin-bottom: 5px;
		}
	}
	@media (min-width: 992px) and (max-width: 1199px){
		.top{
			width:992px;
			height:67px;
		}
		#logo{
			width: 123px;
		}
		footer{
			padding-bottom: 35px;
			padding-top: 30px;
		}
		.footer-upper-1>img{
			width: 90px;
			margin-bottom: 10px;
		}
	}
	@media (min-width: 768px) and (max-width: 991px) {
		.top{
			width:768px;
			height:50px;
		}
		#logo{
			width: 108px;
		}
		footer{
			padding-bottom: 31px;
			padding-top: 24px;
		}
		.footer-upper-1>img{
			width: 69px;
			margin-bottom: 10px;
		}
	} */
</style>
